import React from 'react';
import { clsx } from 'clsx';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'brawn' | 'brains';
}
export function Card({
  children,
  className,
  variant = 'default'
}: CardProps) {
  const baseStyles = 'p-6 md:p-8 rounded-lg border backdrop-blur-sm';
  const variants = {
    default: 'bg-zinc-900/80 border-zinc-800',
    brawn: 'bg-orange-950/20 border-orange-900/50 shadow-[0_0_30px_rgba(234,88,12,0.1)]',
    brains: 'bg-cyan-950/20 border-cyan-900/50 shadow-[0_0_30px_rgba(8,145,178,0.1)]'
  };
  return <div className={clsx(baseStyles, variants[variant], className)} data-id="element-234">
      {children}
    </div>;
}